// axiosConfig.js
import axios from 'axios';

// Adicionar o token às requisições
axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token'); // ou sessionStorage.getItem('token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export default axios;
